<script setup lang="ts">
import { nextTick, ref, watch } from 'vue'
import type { IAreaSensor, IManagementArea } from '@/interfaces/entities/management'
import { useManagementStore } from '@/store/management'
import AreaColumn from './AreaColumn.vue'

const store = useManagementStore()

const emit = defineEmits<{
  (e: 'add-area', parentId: number | null): void
  (e: 'add-sensor', area: IManagementArea): void
  (e: 'edit-area', area: IManagementArea): void
  (e: 'remove-area', area: IManagementArea): void
  (e: 'edit-sensor', payload: { area: IManagementArea; areaSensor: IAreaSensor }): void
  (e: 'remove-sensor', payload: { area: IManagementArea; areaSensor: IAreaSensor }): void
}>()

const scroller = ref<HTMLElement | null>(null)

// Ao aprofundar nas colunas, rola para mostrar a coluna mais à direita.
watch(
  () => store.selectedPath.length,
  async () => {
    await nextTick()
    if (scroller.value) scroller.value.scrollLeft = scroller.value.scrollWidth
  },
)
</script>

<template>
  <div ref="scroller" class="flex items-stretch overflow-x-auto border border-stroke bg-slate-100">
    <AreaColumn
      v-for="(parent, index) in store.columnParents"
      :key="parent ? `col-${parent.id}` : 'col-root'"
      :parent="parent"
      :column-index="index"
      @add-area="emit('add-area', $event)"
      @add-sensor="emit('add-sensor', $event)"
      @edit-area="emit('edit-area', $event)"
      @remove-area="emit('remove-area', $event)"
      @edit-sensor="emit('edit-sensor', $event)"
      @remove-sensor="emit('remove-sensor', $event)" />
  </div>
</template>
